import { IconChatUIAlert } from 'components/Icons';
import styled from 'styled-components';

export const StyledReconnectWrapper = styled.div`
  display: flex;
  height: inherit;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  span {
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing['2Xl']};
  }
`;

export const StyledAlertIcon = styled(IconChatUIAlert)`
  width: 6.5rem;
  height: 6.5rem;
`;
